'use client';

import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-lg font-bold text-white mb-2">CatanduvasPR.com.br</p>
        <p className="mb-6">
          Portal de utilidade pública independente. Produzido e administrado por{' '}
          <a 
            href="https://estudiomidia.com.br/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white hover:text-blue-400 underline underline-offset-4 transition-colors"
          >
            Estúdio Mídia Publicidades
          </a>
        </p>
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8 text-sm font-bold uppercase tracking-widest">
          <Link to="/sobre" className="hover:text-white transition-colors">Sobre o Portal</Link>
          <Link to="/contato" className="hover:text-white transition-colors">Contato</Link>
          <Link to="/termos" className="hover:text-white transition-colors">Termos de Uso</Link>
          <Link to="/privacidade" className="hover:text-white transition-colors">Privacidade</Link>
        </div>
        <p className="text-sm">© {new Date().getFullYear()} Catanduvas PR. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
